import { IAzureAuthentication } from "../interfaces/iazureauthentication";
import * as azureAuthentications from "../actions/azureauthentication.action";

const initialState: IAzureAuthentication = {
    token: null,
    tokenExpired: false,
    loggedOut: false,
    unauthorizedAccessAttempt: false
};

export function azureAuthenticationReducer(state: IAzureAuthentication = initialState,
    action: azureAuthentications.Actions): IAzureAuthentication {

    switch(action.type) {
        case azureAuthentications.actionTypes.SET_TOKEN:
            return {
                ...state,
                token: (action as azureAuthentications.SetTokenAction).payload.token
            };
        case azureAuthentications.actionTypes.SET_TOKEN_EXPIRED:
            return {
                ...state,
                token: null,
                tokenExpired: true
            };
        case azureAuthentications.actionTypes.SET_LOGGED_OUT:
            const loggedOut: boolean = (action as azureAuthentications.LoggedOutAction).payload;
            if(loggedOut) {
                return {
                    ...state,
                    token: null,
                    loggedOut: true
                };
            } else {
                return {
                    ...state,
                    loggedOut: false
                };
            }
        case azureAuthentications.actionTypes.RESET_TOKEN_EXPIRED:
            return {
                ...state,
                tokenExpired: false
            };
        case azureAuthentications.actionTypes.UNAUTHORIZED_ACCESS_ATTEMPT:
            return {
                ...state,
                unauthorizedAccessAttempt: true
            };
        case azureAuthentications.actionTypes.RESET_UNAUTHORIZED_ACCESS_ATTEMPT:
            return {
                ...state,
                unauthorizedAccessAttempt: false
            };
        default:
            return state;
    }
}